import { Directive, OnInit, ElementRef, HostListener } from "@angular/core";

@Directive({
  selector: "[numberOnly]"
})
export class NumbersOnlyDirective {
  regexStr = "^[0-9]+$";
  constructor(private el: ElementRef) {
    console.log("constructor triggered", el);
  }

  @HostListener("keydown", ["$event"])
  onKeyDown(event) {
    console.log('directive works');
    return new RegExp(this.regexStr).test(event.key);
  }
}
